import { API_endpoints } from "../config";

export const updateCost = async (id: string, data: { category: string; price: number; }) => {
    try {
        const response = await fetch(API_endpoints.updateCost, {
            method: "POST", 
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ id, ...data }),  
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Aktualisieren der Tarif Anfrage");
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("Fehler beim Aktualisieren der Tarif Anfrage:", error);
        throw error;
    }
};
